import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyDtT8thtCUWWTzEqK82UcKiPd__Gt733ps",
  authDomain: "magic-moments-b6d76.firebaseapp.com",
  projectId: "magic-moments-b6d76",
  storageBucket: "magic-moments-b6d76.appspot.com",
  messagingSenderId: "899046188015",
  appId: "1:899046188015:web:6d0bdb117300fd9ad80c1a"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
